<template>
  <div class="fade-in">
    <form @submit.prevent="onSubmit">
      <div class="field">
        <label>Name:</label>
        <div class="control">
          <input
            type="text"
            v-model="model.name"
            class="input"
            name="name"
            required
          />
        </div>
      </div>

      <div class="field">
        <label>Interview Type:</label>
        <div class="control select">
          <select v-model="model.kind">
            <option value="Schedule">Schedule</option>
            <option v-if="model.id" value="PHQ_9" disabled>PHQ-9</option>
            <option value="Referral_Provider">Referral Provider</option>
            <option value="Referral_Patient">Referral Patient</option>
          </select>
        </div>
      </div>

      <div class="field">
        <label>Tags:</label>
        <multiselect
          v-model="model.tagList"
          :options="taggingOptions"
          :multiple="true"
          :taggable="true"
          @tag="addTag"
          tag-placeholder="Add this as new tag"
          placeholder="Type to search or add tag"
          label="label"
          trackBy="label"
        />
      </div>

      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            {{ submitText }}
          </button>
        </div>
        <div class="control">
          <router-link :to="{ name: 'interview-pool' }" class="button is-link"
            >Cancel
          </router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import multiselect from "vue-multiselect";

export default {
  name: "interview-form",

  props: ["model", "loading", "onSubmit", "submitText"],

  components: {
    multiselect
  },

  data() {
    return {
      taggingOptions: []
    };
  },

  methods: {
    addTag(newTag) {
      const tag = { label: newTag };
      this.taggingOptions.push(tag);
      this.model.tagList.push(tag);
    }
  },

  mounted() {
    InterviewsService.getTags().then(() => {
      const tags = this.$store.getters["interview/tags"];
      this.taggingOptions = tags.map(tag => {
        const label = { label: tag.name };
        return label;
      });
    });
  }
};
</script>

<style lang="scss"></style>
